import { TenantState } from "./tenant.state";

export const selectTenant = (state: TenantState) => state.tenant;
export const selectTenantLoading = (state: TenantState) => state.loading;
export const selectTenantError = (state: TenantState) => state.error;
export const selectTenantTitle = (state: TenantState) => state.tenant?.title; 